import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b40bbf2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Search_Contents" }
const _hoisted_2 = { class: "Search_Contents_Title" }
const _hoisted_3 = { class: "Search_Contents_List" }
const _hoisted_4 = ["type", "value"]

import { ref, watch } from "vue";

// props
interface Props {
  // css調整用----------
  titleMinWidth?: string;
  titleMaxWidth?: string;
  listMinWidth?: string;
  inputMinWidth?: string;
  // -------------------
  initialData: string; // 初期値
  title: string;
  type: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'searchInputText',
  props: {
    titleMinWidth: {},
    titleMaxWidth: {},
    listMinWidth: {},
    inputMinWidth: {},
    initialData: {},
    title: {},
    type: {}
  },
  emits: ["change"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "5a39d986": (props.titleMaxWidth !== undefined?props.titleMaxWidth : '90px'),
  "7623cee2": (props.titleMinWidth !== undefined?props.titleMinWidth : '90px'),
  "57d39831": (props.listMinWidth !== undefined?props.listMinWidth : '224px'),
  "75a8d566": (props.inputMinWidth !== undefined?props.inputMinWidth : 'initial')
}))

const props = __props;
// emit
const emit = __emit;

const inputValue = ref("" as string);
// 初期値の格納
watch(
  () => props.initialData,
  () => {
    if (props.initialData !== undefined) {
      inputValue.value = props.initialData;
    }
  },
  { immediate: true }
);
const chengeInput = (e: Event) => {
  if (!(e.target instanceof HTMLInputElement)) throw new TypeError();
  inputValue.value = e.target.value;
  emit("change", inputValue.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("input", {
        type: _ctx.type,
        onChange: chengeInput,
        value: inputValue.value,
        class: _normalizeClass(["InputText_Input", { Input_MinWidth: props.inputMinWidth !== undefined }])
      }, null, 42, _hoisted_4)
    ])
  ]))
}
}

})